import { render } from "./TradePermitUBP.vue?vue&type=template&id=02388ece&scoped=true"
import script from "./TradePermitUBP.vue?vue&type=script&lang=js"
export * from "./TradePermitUBP.vue?vue&type=script&lang=js"

import "./TradePermitUBP.vue?vue&type=style&index=0&id=02388ece&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02388ece"]])

export default __exports__